import { BottomSheetDialog, Box } from '@medely/web-components';
import { WorkHistoryFormContainer } from '@mp/components/workHistoryForm/WorkHistoryFormContainer';
import useDevice from '@mp/hooks/useDevice.web';
import React from 'react';
import { WorkHistoryModalProps } from './interface';

export const WorkHistoryModal = ({
  open,
  onClose,
  workHistory,
  experienceType,
}: WorkHistoryModalProps) => {
  const isDesktop = useDevice() === 'desktop';
  const isEdit = !!workHistory;
  const titlePrefix = isEdit ? 'Edit' : 'Add';
  const title =
    experienceType === 'clinical'
      ? `${titlePrefix} clinical experience`
      : `${titlePrefix} non-clinical experience`;

  return (
    <BottomSheetDialog
      maxWidth={false}
      open={open}
      onClose={onClose}
      title={title}
      data-testid="work-history-modal"
      content={
        <Box width="90vw" maxWidth="600px">
          <WorkHistoryFormContainer
            goBack={onClose}
            workHistory={workHistory}
            experienceType={experienceType}
            isModal
          />
        </Box>
      }
      isDesktop={isDesktop}
    />
  );
};
